import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import VideoDemo from './components/VideoDemo';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Partners from './components/Partners';
import Testimonials from './components/Testimonials';
import MoneyBackGuarantee from './components/MoneyBackGuarantee';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Partners />
      <Features />
      <VideoDemo />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <MoneyBackGuarantee />
      <Contact />
      <Footer />
    </div>
  );
}
